import Model from '@/models/Model'

export default class APrevired extends Model {
    resource() {
        return 'previred'
    }
}
